<template>
  <div id="app">
    <div class="wrapper">
      <div class="default-content">
        <Notification />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Notification from '../views/Notification'

export default {
  name: 'Default',
  components: {
    Notification
  }
}
</script>

<style lang="scss">
@import '../global.scss';

.default-content {
  width: 100%;
  height: 100%;
}

@media (max-width: 1100px) {
  .notifications {
    width: 100%;
    margin: 0px 0px;
  }
}
</style>
